import { pick, isEmpty, keys, omit, sortBy } from 'lodash';
import { req } from 'react-reqq-lite';

import {
  removeEmpty,
  formatGetQueryParams,
  removeNull,
} from 'modules/common/utils';

const key = {
  id: '',
  name: '',
  logo: '',
  status: '',
  key: '',
  uuid: '',
  is_active: '',
  is_enabled: '',
  is_same_day_delivery: '',
  is_required_billing_details: '',
  type: '',
};

export const DELIVERY_OPTS = [
  {
    label: 'Customer Pick-up',
    value: 'PICK_UP',
    description: 'Allow your customers to pickup orders at your store',
  },
  {
    label: 'In-House Rider',
    value: 'IN_HOUSE',
    description: 'Fulfill orders with your own delivery guys',
  },
  {
    label: 'Delivery Partners',
    value: '3RD_PARTY',
    description:
      'Fulfill orders with our delivery partners (same-day or scheduled deliveries)',
  },
];

export const PATYMENT_OPTS = [
  {
    label: 'Cash On Delivery',
    value: 'CASH_ON_DELIVERY',
    description: 'Allow your customers to pay orders upon receipt',
  },
  {
    label: 'Over the Counter Payments',
    value: 'OVER_THE_COUNTER',
    description: 'Allow your customers to pay orders over the counter',
  },
  {
    label: 'Credit or Debit Card',
    value: 'CREDIT_DEBIT',
    description: 'Allow your customers to pay through debit/credit cards',
  },
  {
    label: 'E-Payment',
    value: 'PAYMENT_GATEWAY',
    description: 'Allow your customers to pay through digital wallet',
  },
  {
    label: 'Bank',
    value: 'BANK_TRANSFER',
    description: 'Allow your customers to pay through banks',
  },
];

export const transformData = (data) => {
  const { attributes } = data;

  const args = {
    ...data,
    ...attributes,
    logo: attributes?.banner_logo ?? attributes?.logo,
    is_required_billing_details: attributes?.is_required_billing_details,
    id: data?.id,
  };

  return { ...pick(args, keys(key)) };
};

export const getDeliveryCouriersList = () => {
  req.get({
    url: `/v1/delivery-couriers`,
    key: 'COMMON/GET_DELIVERY_COURIERS',
    transform: ({ data }) => ({
      data: data?.map(transformData),
      method_options: DELIVERY_OPTS,
    }),
    cacheKey: 'delivery-couriers',
  });
};

export const getPaymentChannelMethods = () => {
  req.get({
    url: '/v1/payment-channel',
    key: 'COMMON/PAYMENT_CHANNEL_METHODS',
    params: {
      per_page: 100,
    },
    transform: ({ data }) => ({
      data: data?.map((x) => {
        const $x = {
          ...x,
          key:
            x?.attributes?.key === 'visamastercard'
              ? 'visa-mastercard'
              : x?.attributes?.key,
        };

        return transformData($x);
      }),
      method_options: PATYMENT_OPTS,
    }),
    cacheKey: 'payment-methods',
  });
};

export const tranformCategory = (data) => {
  const formatCategory = (list) => {
    const x = list?.map((item) => {
      const { children_recursive, category_groups, categories } = item || {};

      if (
        !isEmpty(children_recursive) ||
        !isEmpty(category_groups) ||
        !isEmpty(categories)
      ) {
        const y = formatCategory([
          ...(children_recursive || []),
          ...(category_groups || []),
          ...(categories || []),
        ]).map((c) => ({
          ...c,
          parent_label: item?.title,
          parent_value: item?.uuid,
        }));

        return {
          child: y?.length ? sortBy(y, (o) => o?.label.toLowerCase()) : [],
          label: item?.title,
          value: item?.uuid,
        };
      }

      return {
        child: [],
        label: item?.title,
        value: item?.uuid,
      };
    });
    return x;
  };

  const $data = data
    ? formatCategory(data)?.filter((item) => item?.child?.length > 0)
    : [];
  return $data;
};

const transformCategoryParams = (params) => {
  const x = formatGetQueryParams(params);
  return removeNull(removeEmpty(x));
};

export const getCategoryList = (params) => {
  req.get({
    key: 'COMMON/CATEGORY_LIST',
    url: '/v2/categories-recursive',
    params: transformCategoryParams(params),
    transform: (res) => {
      const $data = tranformCategory(res);
      return $data;
    },
  });
};

const transformRemittancePartner = (item) => {
  const x = {
    ...omit(item, ['attributes', 'links', 'types']),
    ...item?.attributes,
  };
  return x;
};

export const getRemittancePartner = () => {
  req.get({
    key: 'COMMON/REMITTANCE_PARTNER',
    url: '/v1/remittance/partners',
    params: {
      per_page: 100,
    },
    transform: ({ data }) => {
      const x = data?.map((item) => transformRemittancePartner(item));
      return x;
    },
    cacheKey: 'COMMON/REMITTANCE_PARTNER',
  });
};
